/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AvailabilityResponse,
  BookingCreateRequest,
  BookingLookupResponse,
  BookingResponse,
  BrandListResponse,
  DataProductCatalogResponse,
  DataProductDefinition,
  DataProductEndpointMapping,
  DataProductMappingConfigResponse,
  DataProductMappingSource,
  DataProductMappingTestResponse,
  DataProductMappingValidationResult,
  DataProductSourceLogoUpdate,
  GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams,
  HTTPValidationError,
  ItineraryResponse,
  ListTripsApiTtcDataProductsTripsGetParams,
  SrcApiTtcDataProductSchemasAppletConfigResponse,
  TelemetryStatusResponse,
  TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody,
  TripDetailResponse,
  TripListResponse,
  ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * @summary Get TTC Data Products applet configuration
 */
export const getConfigApiTtcDataProductsConfigGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SrcApiTtcDataProductSchemasAppletConfigResponse>(
      {url: `/api/ttc/data-products/config`, method: 'GET', signal
    },
      );
    }
  



export const getGetConfigApiTtcDataProductsConfigGetQueryKey = () => {
    return [
    `/api/ttc/data-products/config`
    ] as const;
    }

    
export const getGetConfigApiTtcDataProductsConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigApiTtcDataProductsConfigGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>> = ({ signal }) => getConfigApiTtcDataProductsConfigGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetConfigApiTtcDataProductsConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>>
export type GetConfigApiTtcDataProductsConfigGetQueryError = unknown


export function useGetConfigApiTtcDataProductsConfigGet<TData = Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigApiTtcDataProductsConfigGet<TData = Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetConfigApiTtcDataProductsConfigGet<TData = Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get TTC Data Products applet configuration
 */

export function useGetConfigApiTtcDataProductsConfigGet<TData = Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfigApiTtcDataProductsConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetConfigApiTtcDataProductsConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get TTC Data Products Langfuse telemetry status
 */
export const getTelemetryStatusApiTtcDataProductsTelemetryStatusGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<TelemetryStatusResponse>(
      {url: `/api/ttc/data-products/telemetry/status`, method: 'GET', signal
    },
      );
    }
  



export const getGetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryKey = () => {
    return [
    `/api/ttc/data-products/telemetry/status`
    ] as const;
    }

    
export const getGetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryOptions = <TData = Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>> = ({ signal }) => getTelemetryStatusApiTtcDataProductsTelemetryStatusGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>>
export type GetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryError = unknown


export function useGetTelemetryStatusApiTtcDataProductsTelemetryStatusGet<TData = Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTelemetryStatusApiTtcDataProductsTelemetryStatusGet<TData = Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>,
          TError,
          Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTelemetryStatusApiTtcDataProductsTelemetryStatusGet<TData = Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get TTC Data Products Langfuse telemetry status
 */

export function useGetTelemetryStatusApiTtcDataProductsTelemetryStatusGet<TData = Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTelemetryStatusApiTtcDataProductsTelemetryStatusGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTelemetryStatusApiTtcDataProductsTelemetryStatusGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary List TTC Data Product API products
 */
export const listDataProductsApiTtcDataProductsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductCatalogResponse>(
      {url: `/api/ttc/data-products`, method: 'GET', signal
    },
      );
    }
  



export const getListDataProductsApiTtcDataProductsGetQueryKey = () => {
    return [
    `/api/ttc/data-products`
    ] as const;
    }

    
export const getListDataProductsApiTtcDataProductsGetQueryOptions = <TData = Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDataProductsApiTtcDataProductsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>> = ({ signal }) => listDataProductsApiTtcDataProductsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListDataProductsApiTtcDataProductsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>>
export type ListDataProductsApiTtcDataProductsGetQueryError = unknown


export function useListDataProductsApiTtcDataProductsGet<TData = Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>,
          TError,
          Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDataProductsApiTtcDataProductsGet<TData = Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>,
          TError,
          Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDataProductsApiTtcDataProductsGet<TData = Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List TTC Data Product API products
 */

export function useListDataProductsApiTtcDataProductsGet<TData = Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductsApiTtcDataProductsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListDataProductsApiTtcDataProductsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary List configurable data product definitions
 */
export const listDataProductDefinitionsApiTtcDataProductsDefinitionsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductCatalogResponse>(
      {url: `/api/ttc/data-products/definitions`, method: 'GET', signal
    },
      );
    }
  



export const getListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryKey = () => {
    return [
    `/api/ttc/data-products/definitions`
    ] as const;
    }

    
export const getListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryOptions = <TData = Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>> = ({ signal }) => listDataProductDefinitionsApiTtcDataProductsDefinitionsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>>
export type ListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryError = unknown


export function useListDataProductDefinitionsApiTtcDataProductsDefinitionsGet<TData = Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>,
          TError,
          Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDataProductDefinitionsApiTtcDataProductsDefinitionsGet<TData = Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>,
          TError,
          Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListDataProductDefinitionsApiTtcDataProductsDefinitionsGet<TData = Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List configurable data product definitions
 */

export function useListDataProductDefinitionsApiTtcDataProductsDefinitionsGet<TData = Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDataProductDefinitionsApiTtcDataProductsDefinitionsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListDataProductDefinitionsApiTtcDataProductsDefinitionsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Stores a custom TTC data product definition in deployment-scoped applet persistence.
 * @summary Create or replace a custom data product definition
 */
export const saveDataProductDefinitionApiTtcDataProductsDefinitionsPost = (
    dataProductDefinition: DataProductDefinition,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductDefinition>(
      {url: `/api/ttc/data-products/definitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dataProductDefinition, signal
    },
      );
    }
  


export const getSaveDataProductDefinitionApiTtcDataProductsDefinitionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>, TError,{data: DataProductDefinition}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>, TError,{data: DataProductDefinition}, TContext> => {

const mutationKey = ['saveDataProductDefinitionApiTtcDataProductsDefinitionsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>, {data: DataProductDefinition}> = (props) => {
          const {data} = props ?? {};

          return  saveDataProductDefinitionApiTtcDataProductsDefinitionsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveDataProductDefinitionApiTtcDataProductsDefinitionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>>
    export type SaveDataProductDefinitionApiTtcDataProductsDefinitionsPostMutationBody = DataProductDefinition
    export type SaveDataProductDefinitionApiTtcDataProductsDefinitionsPostMutationError = HTTPValidationError

    /**
 * @summary Create or replace a custom data product definition
 */
export const useSaveDataProductDefinitionApiTtcDataProductsDefinitionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>, TError,{data: DataProductDefinition}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveDataProductDefinitionApiTtcDataProductsDefinitionsPost>>,
        TError,
        {data: DataProductDefinition},
        TContext
      > => {

      const mutationOptions = getSaveDataProductDefinitionApiTtcDataProductsDefinitionsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Delete a custom data product definition
 */
export const deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete = (
    productId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/ttc/data-products/definitions/${productId}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>, TError,{productId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>, TError,{productId: string}, TContext> => {

const mutationKey = ['deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>, {productId: string}> = (props) => {
          const {productId} = props ?? {};

          return  deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete(productId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>>
    
    export type DeleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete a custom data product definition
 */
export const useDeleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>, TError,{productId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDelete>>,
        TError,
        {productId: string},
        TContext
      > => {

      const mutationOptions = getDeleteDataProductDefinitionApiTtcDataProductsDefinitionsProductIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get endpoint-to-schema mapping configuration
 */
export const getMappingConfigApiTtcDataProductsMappingsConfigGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductMappingConfigResponse>(
      {url: `/api/ttc/data-products/mappings/config`, method: 'GET', signal
    },
      );
    }
  



export const getGetMappingConfigApiTtcDataProductsMappingsConfigGetQueryKey = () => {
    return [
    `/api/ttc/data-products/mappings/config`
    ] as const;
    }

    
export const getGetMappingConfigApiTtcDataProductsMappingsConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMappingConfigApiTtcDataProductsMappingsConfigGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>> = ({ signal }) => getMappingConfigApiTtcDataProductsMappingsConfigGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMappingConfigApiTtcDataProductsMappingsConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>>
export type GetMappingConfigApiTtcDataProductsMappingsConfigGetQueryError = unknown


export function useGetMappingConfigApiTtcDataProductsMappingsConfigGet<TData = Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMappingConfigApiTtcDataProductsMappingsConfigGet<TData = Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMappingConfigApiTtcDataProductsMappingsConfigGet<TData = Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get endpoint-to-schema mapping configuration
 */

export function useGetMappingConfigApiTtcDataProductsMappingsConfigGet<TData = Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMappingConfigApiTtcDataProductsMappingsConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMappingConfigApiTtcDataProductsMappingsConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create or update an endpoint-to-schema mapping
 */
export const saveEndpointMappingApiTtcDataProductsMappingsPost = (
    dataProductEndpointMapping: DataProductEndpointMapping,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductEndpointMapping>(
      {url: `/api/ttc/data-products/mappings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dataProductEndpointMapping, signal
    },
      );
    }
  


export const getSaveEndpointMappingApiTtcDataProductsMappingsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>, TError,{data: DataProductEndpointMapping}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>, TError,{data: DataProductEndpointMapping}, TContext> => {

const mutationKey = ['saveEndpointMappingApiTtcDataProductsMappingsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>, {data: DataProductEndpointMapping}> = (props) => {
          const {data} = props ?? {};

          return  saveEndpointMappingApiTtcDataProductsMappingsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveEndpointMappingApiTtcDataProductsMappingsPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>>
    export type SaveEndpointMappingApiTtcDataProductsMappingsPostMutationBody = DataProductEndpointMapping
    export type SaveEndpointMappingApiTtcDataProductsMappingsPostMutationError = HTTPValidationError

    /**
 * @summary Create or update an endpoint-to-schema mapping
 */
export const useSaveEndpointMappingApiTtcDataProductsMappingsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>, TError,{data: DataProductEndpointMapping}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveEndpointMappingApiTtcDataProductsMappingsPost>>,
        TError,
        {data: DataProductEndpointMapping},
        TContext
      > => {

      const mutationOptions = getSaveEndpointMappingApiTtcDataProductsMappingsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Validate an endpoint-to-schema mapping
 */
export const validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost = (
    mappingId: string,
    validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductMappingValidationResult>(
      {url: `/api/ttc/data-products/mappings/${mappingId}/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody, signal
    },
      );
    }
  


export const getValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>, TError,{mappingId: string;data: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>, TError,{mappingId: string;data: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody}, TContext> => {

const mutationKey = ['validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>, {mappingId: string;data: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody}> = (props) => {
          const {mappingId,data} = props ?? {};

          return  validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost(mappingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostMutationResult = NonNullable<Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>>
    export type ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostMutationBody = ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody
    export type ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostMutationError = HTTPValidationError

    /**
 * @summary Validate an endpoint-to-schema mapping
 */
export const useValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>, TError,{mappingId: string;data: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePost>>,
        TError,
        {mappingId: string;data: ValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostBody},
        TContext
      > => {

      const mutationOptions = getValidateEndpointMappingApiTtcDataProductsMappingsMappingIdValidatePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Test a mapping and preview normalized Data Products output
 */
export const testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost = (
    mappingId: string,
    testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductMappingTestResponse>(
      {url: `/api/ttc/data-products/mappings/${mappingId}/test`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody, signal
    },
      );
    }
  


export const getTestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>, TError,{mappingId: string;data: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>, TError,{mappingId: string;data: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody}, TContext> => {

const mutationKey = ['testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>, {mappingId: string;data: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody}> = (props) => {
          const {mappingId,data} = props ?? {};

          return  testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost(mappingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostMutationResult = NonNullable<Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>>
    export type TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostMutationBody = TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody
    export type TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostMutationError = HTTPValidationError

    /**
 * @summary Test a mapping and preview normalized Data Products output
 */
export const useTestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>, TError,{mappingId: string;data: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testEndpointMappingApiTtcDataProductsMappingsMappingIdTestPost>>,
        TError,
        {mappingId: string;data: TestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostBody},
        TContext
      > => {

      const mutationOptions = getTestEndpointMappingApiTtcDataProductsMappingsMappingIdTestPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Set a manually uploaded source logo
 */
export const saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost = (
    sourceId: string,
    dataProductSourceLogoUpdate: DataProductSourceLogoUpdate,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DataProductMappingSource>(
      {url: `/api/ttc/data-products/sources/${sourceId}/logo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dataProductSourceLogoUpdate, signal
    },
      );
    }
  


export const getSaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>, TError,{sourceId: string;data: DataProductSourceLogoUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>, TError,{sourceId: string;data: DataProductSourceLogoUpdate}, TContext> => {

const mutationKey = ['saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>, {sourceId: string;data: DataProductSourceLogoUpdate}> = (props) => {
          const {sourceId,data} = props ?? {};

          return  saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost(sourceId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPostMutationResult = NonNullable<Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>>
    export type SaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPostMutationBody = DataProductSourceLogoUpdate
    export type SaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPostMutationError = HTTPValidationError

    /**
 * @summary Set a manually uploaded source logo
 */
export const useSaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>, TError,{sourceId: string;data: DataProductSourceLogoUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPost>>,
        TError,
        {sourceId: string;data: DataProductSourceLogoUpdate},
        TContext
      > => {

      const mutationOptions = getSaveSourceLogoApiTtcDataProductsSourcesSourceIdLogoPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List TTC brands
 */
export const listBrandsApiTtcDataProductsBrandsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<BrandListResponse>(
      {url: `/api/ttc/data-products/brands`, method: 'GET', signal
    },
      );
    }
  



export const getListBrandsApiTtcDataProductsBrandsGetQueryKey = () => {
    return [
    `/api/ttc/data-products/brands`
    ] as const;
    }

    
export const getListBrandsApiTtcDataProductsBrandsGetQueryOptions = <TData = Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBrandsApiTtcDataProductsBrandsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>> = ({ signal }) => listBrandsApiTtcDataProductsBrandsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListBrandsApiTtcDataProductsBrandsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>>
export type ListBrandsApiTtcDataProductsBrandsGetQueryError = unknown


export function useListBrandsApiTtcDataProductsBrandsGet<TData = Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>,
          TError,
          Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListBrandsApiTtcDataProductsBrandsGet<TData = Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>,
          TError,
          Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListBrandsApiTtcDataProductsBrandsGet<TData = Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List TTC brands
 */

export function useListBrandsApiTtcDataProductsBrandsGet<TData = Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBrandsApiTtcDataProductsBrandsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListBrandsApiTtcDataProductsBrandsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Search productized TTC trip inventory with business-friendly filters such as brand, waterway, country, date, price, duration, and availability.
 * @summary Search trips and river cruises
 */
export const listTripsApiTtcDataProductsTripsGet = (
    params?: ListTripsApiTtcDataProductsTripsGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TripListResponse>(
      {url: `/api/ttc/data-products/trips`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getListTripsApiTtcDataProductsTripsGetQueryKey = (params?: ListTripsApiTtcDataProductsTripsGetParams,) => {
    return [
    `/api/ttc/data-products/trips`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListTripsApiTtcDataProductsTripsGetQueryOptions = <TData = Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError = HTTPValidationError>(params?: ListTripsApiTtcDataProductsTripsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTripsApiTtcDataProductsTripsGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>> = ({ signal }) => listTripsApiTtcDataProductsTripsGet(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListTripsApiTtcDataProductsTripsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>>
export type ListTripsApiTtcDataProductsTripsGetQueryError = HTTPValidationError


export function useListTripsApiTtcDataProductsTripsGet<TData = Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError = HTTPValidationError>(
 params: undefined |  ListTripsApiTtcDataProductsTripsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>,
          TError,
          Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTripsApiTtcDataProductsTripsGet<TData = Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError = HTTPValidationError>(
 params?: ListTripsApiTtcDataProductsTripsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>,
          TError,
          Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListTripsApiTtcDataProductsTripsGet<TData = Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError = HTTPValidationError>(
 params?: ListTripsApiTtcDataProductsTripsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search trips and river cruises
 */

export function useListTripsApiTtcDataProductsTripsGet<TData = Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError = HTTPValidationError>(
 params?: ListTripsApiTtcDataProductsTripsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTripsApiTtcDataProductsTripsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListTripsApiTtcDataProductsTripsGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get trip detail
 */
export const getTripApiTtcDataProductsTripsTripIdGet = (
    tripId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<TripDetailResponse>(
      {url: `/api/ttc/data-products/trips/${tripId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetTripApiTtcDataProductsTripsTripIdGetQueryKey = (tripId?: string,) => {
    return [
    `/api/ttc/data-products/trips/${tripId}`
    ] as const;
    }

    
export const getGetTripApiTtcDataProductsTripsTripIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError = HTTPValidationError>(tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTripApiTtcDataProductsTripsTripIdGetQueryKey(tripId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>> = ({ signal }) => getTripApiTtcDataProductsTripsTripIdGet(tripId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tripId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTripApiTtcDataProductsTripsTripIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>>
export type GetTripApiTtcDataProductsTripsTripIdGetQueryError = HTTPValidationError


export function useGetTripApiTtcDataProductsTripsTripIdGet<TData = Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError = HTTPValidationError>(
 tripId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTripApiTtcDataProductsTripsTripIdGet<TData = Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>,
          TError,
          Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTripApiTtcDataProductsTripsTripIdGet<TData = Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get trip detail
 */

export function useGetTripApiTtcDataProductsTripsTripIdGet<TData = Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTripApiTtcDataProductsTripsTripIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTripApiTtcDataProductsTripsTripIdGetQueryOptions(tripId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get trip itinerary
 */
export const getItineraryApiTtcDataProductsTripsTripIdItineraryGet = (
    tripId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ItineraryResponse>(
      {url: `/api/ttc/data-products/trips/${tripId}/itinerary`, method: 'GET', signal
    },
      );
    }
  



export const getGetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryKey = (tripId?: string,) => {
    return [
    `/api/ttc/data-products/trips/${tripId}/itinerary`
    ] as const;
    }

    
export const getGetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryOptions = <TData = Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError = HTTPValidationError>(tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryKey(tripId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>> = ({ signal }) => getItineraryApiTtcDataProductsTripsTripIdItineraryGet(tripId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tripId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryResult = NonNullable<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>>
export type GetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryError = HTTPValidationError


export function useGetItineraryApiTtcDataProductsTripsTripIdItineraryGet<TData = Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError = HTTPValidationError>(
 tripId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>,
          TError,
          Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetItineraryApiTtcDataProductsTripsTripIdItineraryGet<TData = Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>,
          TError,
          Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetItineraryApiTtcDataProductsTripsTripIdItineraryGet<TData = Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get trip itinerary
 */

export function useGetItineraryApiTtcDataProductsTripsTripIdItineraryGet<TData = Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError = HTTPValidationError>(
 tripId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItineraryApiTtcDataProductsTripsTripIdItineraryGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetItineraryApiTtcDataProductsTripsTripIdItineraryGetQueryOptions(tripId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get trip availability and pricing
 */
export const getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet = (
    tripId: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AvailabilityResponse>(
      {url: `/api/ttc/data-products/trips/${tripId}/availability`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryKey = (tripId?: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams,) => {
    return [
    `/api/ttc/data-products/trips/${tripId}/availability`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryOptions = <TData = Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError = HTTPValidationError>(tripId: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryKey(tripId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>> = ({ signal }) => getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet(tripId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tripId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>>
export type GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryError = HTTPValidationError


export function useGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet<TData = Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError = HTTPValidationError>(
 tripId: string,
    params: undefined |  GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>,
          TError,
          Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet<TData = Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError = HTTPValidationError>(
 tripId: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>,
          TError,
          Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet<TData = Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError = HTTPValidationError>(
 tripId: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get trip availability and pricing
 */

export function useGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet<TData = Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError = HTTPValidationError>(
 tripId: string,
    params?: GetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAvailabilityApiTtcDataProductsTripsTripIdAvailabilityGetQueryOptions(tripId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Create a booking or reservation hold
 */
export const createBookingApiTtcDataProductsBookingsPost = (
    bookingCreateRequest: BookingCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingResponse>(
      {url: `/api/ttc/data-products/bookings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookingCreateRequest, signal
    },
      );
    }
  


export const getCreateBookingApiTtcDataProductsBookingsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>, TError,{data: BookingCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>, TError,{data: BookingCreateRequest}, TContext> => {

const mutationKey = ['createBookingApiTtcDataProductsBookingsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>, {data: BookingCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createBookingApiTtcDataProductsBookingsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBookingApiTtcDataProductsBookingsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>>
    export type CreateBookingApiTtcDataProductsBookingsPostMutationBody = BookingCreateRequest
    export type CreateBookingApiTtcDataProductsBookingsPostMutationError = HTTPValidationError

    /**
 * @summary Create a booking or reservation hold
 */
export const useCreateBookingApiTtcDataProductsBookingsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>, TError,{data: BookingCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBookingApiTtcDataProductsBookingsPost>>,
        TError,
        {data: BookingCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateBookingApiTtcDataProductsBookingsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get booking summary and timeline
 */
export const getBookingApiTtcDataProductsBookingsBookingIdGet = (
    bookingId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingLookupResponse>(
      {url: `/api/ttc/data-products/bookings/${bookingId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetBookingApiTtcDataProductsBookingsBookingIdGetQueryKey = (bookingId?: string,) => {
    return [
    `/api/ttc/data-products/bookings/${bookingId}`
    ] as const;
    }

    
export const getGetBookingApiTtcDataProductsBookingsBookingIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError = HTTPValidationError>(bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingApiTtcDataProductsBookingsBookingIdGetQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>> = ({ signal }) => getBookingApiTtcDataProductsBookingsBookingIdGet(bookingId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBookingApiTtcDataProductsBookingsBookingIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>>
export type GetBookingApiTtcDataProductsBookingsBookingIdGetQueryError = HTTPValidationError


export function useGetBookingApiTtcDataProductsBookingsBookingIdGet<TData = Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError = HTTPValidationError>(
 bookingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBookingApiTtcDataProductsBookingsBookingIdGet<TData = Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError = HTTPValidationError>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>,
          TError,
          Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBookingApiTtcDataProductsBookingsBookingIdGet<TData = Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError = HTTPValidationError>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get booking summary and timeline
 */

export function useGetBookingApiTtcDataProductsBookingsBookingIdGet<TData = Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError = HTTPValidationError>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingApiTtcDataProductsBookingsBookingIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBookingApiTtcDataProductsBookingsBookingIdGetQueryOptions(bookingId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



